import { Link, Outlet } from 'react-router-dom'

import { AppHeader } from '@/components/layout/app-header'
import { env } from '@/config/env'
import { useAuth } from '@/app/use-auth'

export function AppLayout() {
  const { user } = useAuth()
  return (
    <div className="min-h-screen bg-background">
      <AppHeader />
      <Outlet />
      {/* Legacy App.tsx: the floating WhatsApp support button, signed-in users only. */}
      {user && env.supportWhatsAppUrl ? (
        <a
          href={env.supportWhatsAppUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Contact support on WhatsApp"
          className="fixed bottom-6 right-6 z-40 grid size-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg hover:brightness-95"
        >
          <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.2c0 1.3.9 2.5 1.1 2.7.1.2 1.9 2.9 4.6 4 1.7.7 2.3.8 3.1.7.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.5-.3z"/></svg>
        </a>
      ) : null}
      <footer className="mx-auto mt-16 flex max-w-[1460px] flex-col gap-2 border-t border-border px-4 py-8 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <span>© 2026 BrightSource. Your career data stays in your control.</span>
        <div className="flex gap-5">
          <Link to="/privacy" className="hover:text-primary">Privacy</Link>
          <Link to="/terms" className="hover:text-primary">Terms</Link>
          <Link to="/help" className="hover:text-primary">Help</Link>
        </div>
      </footer>
    </div>
  )
}
